import { render, staticRenderFns } from "./Quantity.vue?vue&type=template&id=6489c9ce&"
import script from "./Quantity.vue?vue&type=script&lang=js&"
export * from "./Quantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports